export class FileTypeUtils {
    public static mediaTypeConverter(mediaType: string): string {
        const typePatterns: Record<string, RegExp> = {
            pdf: /^application\/pdf$/,
            csv: /^text\/csv$/,
            gif: /^image\/gif$/,
            jpg: /^image\/jpeg$/,
            png: /^image\/png$/,
            xls: /^(application\/vnd\.ms-excel|application\/vnd\.openxmlformats-officedocument\.spreadsheetml\.sheet|application\/xlsx)$/
        };

        for (const [type, pattern] of Object.entries(typePatterns)) {
            if (pattern.test(mediaType)) {
                return type;
            }
        }
        return 'unknown';
    }
}